export default __webpack_public_path__ + "static/media/IMG_9722 copie.38eec46d.jpg";